export default __webpack_public_path__ + "54c72e58bb5065fc021f4f4c203ed1cc.jpg";